<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { Vue3Lottie as LottieAnimation } from "vue3-lottie";

import PulseLogo from "@/assets/lottie/subscription/pulse-logo.json";

import LeSectionHeading from "./LeSectionHeading.vue";

const { t } = useI18n();
</script>

<template>
  <div class="le-order-status-pending">
    <LeSectionHeading />
    <LottieAnimation class="le-order-status-pending__animation" :animation-data="PulseLogo" :width="68" :height="68" />

    <p>{{ t("le-order-status-pending.text") }}</p>
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-order-status-pending {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .body-text("m");
  color: @colors[@neutrals][500];
  text-align: center;

  &__animation {
    margin-top: 64px;
    margin-bottom: 16px;

    #media-breakpoint-up(lg, {
      margin-top: 0;
    });
  }

  :deep(&__animation > svg) {
    width: 68px !important;
    height: 68px !important;
  }
}
</style>
